import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OfferScope } from '../../types';
import { JobsHttpService } from './jobs-http.service';
import { JobItemsActions } from './jobs.store';

@Injectable({
  providedIn: 'root',
})
export class JobsEffects {
  public effects = createEffectFactory(JobItemsActions, this.actions$);

  public fetchActiveCollection$ = this.effects(JobItemsActions.fetchActiveCollection, () =>
    of(JobItemsActions.fetchCollection({ payload: { scope: OfferScope.Active } })),
  );

  public fetchArchivedCollection$ = this.effects(JobItemsActions.fetchArchivedCollection, () =>
    of(JobItemsActions.fetchCollection({ payload: { scope: OfferScope.Archived } })),
  );

  public fetchCollection$ = this.effects(
    JobItemsActions.fetchCollection,
    ({ payload }) =>
      this.jobsHttpService.fetchCollection$(payload!.scope).pipe(
        map(response => ({
          data: response.offers,
          scope: payload!.scope,
        })),
      ),
    {
      customMapOperator: mergeMap,
    },
  );

  public remove$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobItemsActions.removeOnePessimistic),
      mergeMap(({ payload }) =>
        this.jobsHttpService.delete$({ id: <number>payload.data }).pipe(
          switchMap(response => [
            JobItemsActions.removeOnePessimisticSuccess({
              payload: { data: response.offer },
            }),
          ]),
          catchError(error =>
            of(
              JobItemsActions.removeOnePessimisticFailed({
                payload: { error, data: payload.data },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public updatePositions$ = this.effects(JobItemsActions.updatePositions, ({ payload }) =>
    this.jobsHttpService.updatePositions$({ positions: payload }).pipe(
      switchMap(response => of(JobItemsActions.updatePositionSuccess({ payload: response }))),
      catchError(error => of(JobItemsActions.updatePositionsFailed({ payload: { error } }))),
    ),
  );

  constructor(private jobsHttpService: JobsHttpService, private actions$: Actions) {}
}
